
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 4 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.75 2.333a.75.75 0 00-1.5 0h1.5zm-1.5.007a.75.75 0 001.5 0h-1.5zM2.75 7a.75.75 0 00-1.5 0h1.5zm-1.5.007a.75.75 0 001.5 0h-1.5zm1.5 4.66a.75.75 0 10-1.5 0h1.5zm-1.5.006a.75.75 0 001.5 0h-1.5zM2 2.25c.046 0 .083.037.083.083h-1.5c0 .783.635 1.417 1.417 1.417v-1.5zm.083.083A.083.083 0 012 2.417v-1.5C1.218.917.583 1.55.583 2.333h1.5zM2 2.417a.083.083 0 01-.083-.084h1.5C3.417 1.551 2.782.917 2 .917v1.5zm-.083-.084c0-.046.037-.083.083-.083v1.5c.782 0 1.417-.634 1.417-1.417h-1.5zM2 6.917c.046 0 .083.037.083.083h-1.5c0 .782.635 1.417 1.417 1.417v-1.5zM2.083 7A.083.083 0 012 7.083v-1.5C1.218 5.583.583 6.218.583 7h1.5zM2 7.083A.083.083 0 011.917 7h1.5c0-.782-.635-1.417-1.417-1.417v1.5zM1.917 7c0-.046.037-.083.083-.083v1.5c.782 0 1.417-.635 1.417-1.417h-1.5zM2 11.583c.046 0 .083.038.083.084h-1.5c0 .782.635 1.416 1.417 1.416v-1.5zm.083.084A.083.083 0 012 11.75v-1.5c-.782 0-1.417.634-1.417 1.417h1.5zM2 11.75a.083.083 0 01-.083-.083h1.5c0-.783-.635-1.417-1.417-1.417v1.5zm-.083-.083c0-.046.037-.084.083-.084v1.5c.782 0 1.417-.634 1.417-1.416h-1.5zM1.25 2.333v.007h1.5v-.007h-1.5zM1.25 7v.007h1.5V7h-1.5zm0 4.667v.006h1.5v-.006h-1.5z"}})])
          )
        }
      }
    